import { FluidGatsbyImageFieldType, PrismicRichTextFieldType } from '../types';

export enum ImageTypes {
    fullscreen = 'Full screen',
    boxed = 'Boxed',
    two_images = 'Two images',
}

export type VisualImages = {
    images: VisualImage[];
};

export type VisualImage = {
    visual_image: FluidGatsbyImageFieldType;
    visual_image_atl: PrismicRichTextFieldType;
    visual_image_description: PrismicRichTextFieldType;
};

export type VisualProps = {
    slice: {
        slice_type: 'visual';
        primary: {
            visual_image_type: ImageTypes;
        };
        items: VisualImage[];
    };
};
